/** Extract a user-friendly message from an API error response. */
export function getApiError(error: unknown, fallback = 'Something went wrong'): string {
  const err = error as { response?: { data?: { detail?: string | { msg: string }[] } }; message?: string };
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail.map(d => d.msg).join(', ');
  }
  if (err?.message === 'Network Error') return 'Network error — check your connection';
  if ((err as { code?: string }).code === 'ECONNABORTED' || err?.message?.toLowerCase().includes('timeout')) {
    return 'Server is waking up — please wait a moment and try again';
  }
  return fallback;
}
